"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var helper_1 = require("./helper");
var theme_1 = require("./theme");
var Trigger = (function (_super) {
    tslib_1.__extends(Trigger, _super);
    function Trigger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trigger = function (e) {
            if (_this.props.disabled) {
                return;
            }
            if (e._dui_trigger_instances) {
                var index = e._dui_trigger_instances.indexOf(_this);
                if (index !== -1) {
                    e._dui_trigger_instances.splice(index, 1);
                    if (e._dui_trigger_instances.length === 0) {
                        delete e._dui_trigger_instances;
                    }
                    return;
                }
            }
            _this.props.action();
        };
        _this.cancel = function (e) {
            if (_this.props.disabled) {
                return;
            }
            var event = e.nativeEvent;
            if (event._dui_trigger_instances) {
                event._dui_trigger_instances.push(_this);
            }
            else {
                event._dui_trigger_instances = [_this];
            }
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children;
            var classes = classNames(prefixCls, className);
            return (h("div", { className: classes, style: style, onTouchEnd: _this.cancel }, children));
        };
        return _this;
    }
    Trigger.prototype.componentDidMount = function () {
        document.addEventListener('touchend', this.trigger);
    };
    Trigger.prototype.componentWillUnmount = function () {
        document.removeEventListener('touchend', this.trigger);
    };
    Trigger.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Trigger;
}(React.Component));
exports.default = Trigger;
Trigger.defaultProps = {
    prefixCls: 'dui-trigger',
    action: helper_1.emptyFn,
    disabled: false
};
Trigger.propTypes = {
    className: PropTypes.string,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    action: PropTypes.func,
    disabled: PropTypes.bool
};
